module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v3-opt1.331e5c4b.jpg";